import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

export const StepIndicator = ({ currentStep, steps }) => {
    return (
        <div className="w-full px-4 py-6">
            <div className="relative">
                {/* Barra entre centros del primer y último círculo (evita desbordar respecto a los círculos) */}
                <div
                    className="absolute top-5 h-1 left-[calc(1.25rem)] right-[calc(1.25rem)] sm:left-5 sm:right-5"
                    aria-hidden
                >
                    <div className="w-full h-1 bg-gray-200 rounded-full overflow-hidden">
                        <div
                            className="h-1 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full transition-all duration-500 ease-in-out"
                            style={{
                                width: steps.length > 1
                                    ? `${((currentStep - 1) / (steps.length - 1)) * 100}%`
                                    : '0%'
                            }}
                        />
                    </div>
                </div>

                {/* Steps */}
                <div className="relative flex justify-between">
                    {steps.map((step, index) => {
                        const stepNumber = index + 1;
                        const isCompleted = stepNumber < currentStep;
                        const isCurrent = stepNumber === currentStep;
                        const isPending = stepNumber > currentStep;

                        return (
                            <div key={step.id} className="flex flex-col items-center">
                                {/* Step Circle */}
                                <div
                                    className={`
                                        relative z-10 flex items-center justify-center w-10 h-10 rounded-full
                                        transition-all duration-300 border-2
                                        ${isCompleted 
                                            ? 'bg-gradient-to-r from-indigo-600 to-purple-600 border-indigo-600 shadow-lg shadow-indigo-500/50' 
                                            : isCurrent
                                            ? 'bg-white border-indigo-600 ring-4 ring-indigo-100'
                                            : 'bg-white border-gray-300'
                                        }
                                    `}
                                >
                                    {isCompleted ? (
                                        <CheckIcon className="w-5 h-5 text-white" />
                                    ) : (
                                        <span
                                            className={`
                                                text-sm font-bold
                                                ${isCurrent ? 'text-indigo-600' : 'text-gray-400'}
                                            `}
                                        >
                                            {stepNumber}
                                        </span>
                                    )}
                                </div>

                                {/* Step Label */}
                                <div className="mt-3 text-center">
                                    <p
                                        className={`
                                            text-xs font-semibold transition-colors duration-300
                                            ${isCurrent 
                                                ? 'text-indigo-600' 
                                                : isCompleted 
                                                ? 'text-gray-700' 
                                                : 'text-gray-400'
                                            }
                                        `}
                                    >
                                        {step.label}
                                    </p>
                                    {step.description && (
                                        <p className="mt-1 text-xs text-gray-500 hidden sm:block">
                                            {step.description}
                                        </p>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
